import { panoramaClientFactory, PanoramaPlatform, type PanoramaClient } from '@wix/panorama-client-web';
import { PANORAMA_COMPONENT_ID, PANORAMA_FULL_ARTIFACT_ID } from './constants';
import { globalConfig } from './config';

export type { PanoramaClient };

export const panoramaClient: PanoramaClient = panoramaClientFactory({
  baseParams: {
    platform: PanoramaPlatform.Standalone,
    fullArtifactId: PANORAMA_FULL_ARTIFACT_ID,
    componentId: PANORAMA_COMPONENT_ID,
  },
})
  .withGlobalConfig(globalConfig)
  .client();
